<template>
  <v-container fluid>
    <v-row>
      <v-col class="my-0 pt-0">
        <v-switch
          v-model="showInactiveRecords"
          color="primary"
          class="ml-2"
          dense
          hide-details
          inset
          label="Show Inactive/Incomplete"
        />
      </v-col>
    </v-row>
    <v-row>
      <v-col class="my-0 py-0">
        <v-card
          elevation="0"
          outlined
        >
          <v-data-table
            class="glass-record-table"
            :headers="headers"
            :items="filteredItems"
            :footer-props="footer"
            :items-per-page="500"
            :search="search"
            :loading="loading"
            fixed-header
            :height="windowHeight"
            dense
          >
            <template
              v-for="h in headers"
              #[`header.${h.value}`]="{ header }"
            >
              <v-tooltip
                :key="h.value"
                top
              >
                <template #activator="{ on }">
                  <span v-on="on">{{ header.text }}</span>
                </template>
                <span>{{ header.fullText }}</span>
              </v-tooltip>
            </template>
            <template #[`item.row`]="{ item }">
              <text-highlight
                :queries="search"
              >
                {{ item.row }}
              </text-highlight>
            </template>
            <template #[`item.part_number_suffix`]="{ item }">
              <text-highlight
                :queries="search"
              >
                {{ item.part_number_suffix }}
              </text-highlight>
            </template>
            <template #[`item.awd_gas`]="{ item }">
              <text-highlight
                :queries="search"
              >
                {{ item.awd_gas }}
              </text-highlight>
            </template>
            <template #[`item.awd_spacer`]="{ item }">
              <text-highlight
                :queries="search"
              >
                {{ item.awd_spacer }}
              </text-highlight>
            </template>
            <template #[`item.cen_heat_treatment`]="{ item }">
              <text-highlight
                :queries="search"
              >
                {{ item.cen_heat_treatment }}
              </text-highlight>
            </template>
            <template #[`item.center_glass`]="{ item }">
              <text-highlight
                :queries="search"
              >
                {{ item.center_glass }}
              </text-highlight>
            </template>
            <template #[`item.double_triple`]="{ item }">
              <text-highlight
                :queries="search"
              >
                {{ item.double_triple }}
              </text-highlight>
            </template>
            <template #[`item.ext_heat_treatment`]="{ item }">
              <text-highlight
                :queries="search"
              >
                {{ item.ext_heat_treatment }}
              </text-highlight>
            </template>
            <template #[`item.exterior_glass`]="{ item }">
              <text-highlight
                :queries="search"
              >
                {{ item.exterior_glass }}
              </text-highlight>
            </template>
            <template #[`item.fritted`]="{ item }">
              <text-highlight
                :queries="search"
              >
                {{ item.fritted }}
              </text-highlight>
            </template>
            <template #[`item.glass_code`]="{ item }">
              <text-highlight
                :queries="search"
              >
                {{ item.glass_code }}
              </text-highlight>
            </template>
            <template #[`item.int_heat_treatment`]="{ item }">
              <text-highlight
                :queries="search"
              >
                {{ item.int_heat_treatment }}
              </text-highlight>
            </template>
            <template #[`item.interior_glass`]="{ item }">
              <text-highlight
                :queries="search"
              >
                {{ item.interior_glass }}
              </text-highlight>
            </template>
            <template #[`item.le_surface`]="{ item }">
              <text-highlight
                :queries="search"
              >
                {{ item.le_surface }}
              </text-highlight>
            </template>
            <template #[`item.middle_glass`]="{ item }">
              <text-highlight
                :queries="search"
              >
                {{ item.middle_glass }}
              </text-highlight>
            </template>
            <template #[`item.edge_delete`]="{ item }">
              <text-highlight
                :queries="search"
              >
                {{ item.edge_delete }}
              </text-highlight>
            </template>
            <template #[`item.sgl_heat_treatment`]="{ item }">
              <text-highlight
                :queries="search"
              >
                {{ item.sgl_heat_treatment }}
              </text-highlight>
            </template>
            <template #[`item.single_glass`]="{ item }">
              <text-highlight
                :queries="search"
              >
                {{ item.single_glass }}
              </text-highlight>
            </template>
            <template #[`item.spandrel_paint`]="{ item }">
              <text-highlight
                :queries="search"
              >
                {{ item.spandrel_paint }}
              </text-highlight>
            </template>
            <template #[`item.stc`]="{ item }">
              <text-highlight
                :queries="search"
              >
                {{ item.stc }}
              </text-highlight>
            </template>
            <template #[`item.vwd_code`]="{ item }">
              <text-highlight
                :queries="search"
              >
                {{ item.vwd_code }}
              </text-highlight>
            </template>
          </v-data-table>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import TextHighlight from 'vue-text-highlight';
import { mapState, mapGetters } from 'vuex';

export default {
  components: {
    TextHighlight,
  },
  props: {

  },
  data: () => ({
    items: [],
    loading: false,
    showInactiveRecords: false,
    headers: [
      { text: 'G Code', fullText: 'G Code', value: 'row', width: '110px' },
      { text: 'Pt. # Suf.', fullText: 'Part Number Suffix', value: 'part_number_suffix', width: '110px' },
      { text: 'Awd Gas', fullText: 'Awd Gas', value: 'awd_gas', width: '110px' },
      { text: 'Awd Spc.', fullText: 'Awd Spacer', value: 'awd_spacer', width: '110px' },
      { text: 'Cen Heat', fullText: 'Center Heat Treatment', value: 'cen_heat_treatment', width: '110px' },
      { text: 'Cen Glass', fullText: 'Center Glass', value: 'center_glass', width: '110px' },
      { text: 'Dbl / Tpl', fullText: 'Double / Triple', value: 'double_triple', width: '110px' },
      { text: 'Ext Heat', fullText: 'Exterior Heat Treatment', value: 'ext_heat_treatment', width: '110px' },
      { text: 'Ext Glass', fullText: 'Exterior Glass', value: 'exterior_glass', width: '110px' },
      { text: 'Fritted', fullText: 'Fritted', value: 'fritted', width: '110px' },
      { text: 'Glass Code', fullText: 'Glass Code', value: 'glass_code', width: '110px' },
      { text: 'Int Heat', fullText: 'Interior Heat Treatment', value: 'int_heat_treatment', width: '110px' },
      { text: 'Int Glass', fullText: 'Interior Glass', value: 'interior_glass', width: '110px' },
      { text: 'Le Surf.', fullText: 'Le Surface', value: 'le_surface', width: '110px' },
      { text: 'Mid Glass', fullText: 'Middle Glass', value: 'middle_glass', width: '110px' },
      { text: 'Edge Del.', fullText: 'Edge Delete', value: 'edge_delete', width: '110px' },
      { text: 'Sgl Heat', fullText: 'Single Glass Heat Treatment', value: 'sgl_heat_treatment', width: '110px' },
      { text: 'Sgl Glass', fullText: 'Single Glass', value: 'single_glass', width: '110px' },
      { text: 'Sp. Paint', fullText: 'Spandrel Paint', value: 'spandrel_paint', width: '110px' },
      { text: 'Stc', fullText: 'Stc', value: 'stc', width: '110px' },
      { text: 'VWD Code', fullText: 'VWD Code', value: 'vwd_code', width: '110px' },
    ],
    footer: {
      'items-per-page-options': [10, 20, 50, 100, 500, 1000, -1],
    },
    topSpaceHeight: 150,
    windowHeight: 1000,
  }),
  computed: {
    ...mapState({
      search: (state) => state.search,
    }),
    ...mapGetters([

    ]),
    filteredItems() {
      return this.items.filter((item) => {
        const isActivated = Number(item.is_activated) === 1;
        return this.showInactiveRecords ? !isActivated : isActivated;
      });
    },
  },
  created() {
    this.init();
    window.scrollTo(0, document.body.scrollHeight);
    this.windowHeight = window.innerHeight - this.topSpaceHeight;
  },
  mounted() {
    this.$nextTick(() => {
      window.addEventListener('resize', this.onResize);
    });
  },

  beforeDestroy() {
    window.removeEventListener('resize', this.onResize);
  },
  methods: {
    init() {
      this.get();
    },

    async get() {
      this.loading = true;
      this.items = [];
      const submitModel = {
        filters: {
          is_manual: 0,
        },
      };
      const res = await this.$api.glass.readGlassPaintCode(submitModel);
      const cancelCode = 3001;
      if (res === cancelCode) return;
      if (!res) {
        this.items = [];
        this.loading = false;
        return;
      }
      this.items = res;
      this.loading = false;
    },

    onResize() {
      this.windowHeight = window.innerHeight - this.topSpaceHeight;
    },
  },
};
</script>

<style scoped>
::v-deep .glass-record-table > .v-data-table__wrapper {
  overflow-x: auto;
}

::v-deep .glass-record-table > .v-data-table__wrapper > table > thead > tr:last-child > th {
  min-width: 90px;
  white-space: normal;
}

::v-deep .glass-record-table > .v-data-table__wrapper > table > tbody > tr > td,
::v-deep .glass-record-table > .v-data-table__wrapper > table > tbody > tr > td span {
  font-size: 11px !important;
}

::v-deep .glass-record-table > .v-data-table__wrapper > table > thead > tr:last-child > th,
::v-deep .glass-record-table > .v-data-table__wrapper > table > thead > tr:last-child > th span {
  font-size: 11px !important;
}
</style>
